/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import $ from "jquery";
import "dropify/dist/css/dropify.min.css";
import "dropify/dist/js/dropify.min.js";
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";
import { Button } from "react-bootstrap";
import api from "../../utils/api";
import he from "he";
import parse from "html-react-parser";
import "react-toastify/dist/ReactToastify.css";
import {
  FiArrowLeft,
  FiHome,
  FiChevronRight,
  FiBook,
  FiFileText,
  FiList,
  FiType,
  FiUpload,
  FiSave,
  FiEye,
  FiX,
  FiDownload,
  FiCheckCircle,
  FiAlertCircle,
  FiLoader
} from 'react-icons/fi';
import Select from "react-select";


const ImportQuestion = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [selectedModule, setSelectedModule] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedChapter, setSelectedChapter] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("");
  const [fileDetails, setFileDetails] = useState({ questions: [] });
  const [ID, setID] = useState(null);
  const [modules, setModules] = useState([]);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [selectedQuestionType, setSelectedQuestionType] = useState("");
  const [questionType, setQuestionType] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);
  const [userPermissions, setUserPermissions] = useState({});
  const [loading, setLoading] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [file, setFile] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  // Add Chapter modal
  const [showAddChapter, setShowAddChapter] = useState(false);
  const [newChapterName, setNewChapterName] = useState("");
  const [chapterLoading, setChapterLoading] = useState(false);

  // Add Topic modal
  const [showAddTopic, setShowAddTopic] = useState(false);
  const [newTopicName, setNewTopicName] = useState("");
  const [topicLoading, setTopicLoading] = useState(false);
  const [examTypes, setExamTypes] = useState([]);
  const [selectedExamType, setSelectedExamType] = useState([]);

  const [tagInput, setTagInput] = useState("");
  const [tags, setTags] = useState([]);

  const handleTagKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const value = tagInput.trim();
      if (!value) return;

      if (!tags.includes(value)) {
        setTags([...tags, value]);
      }

      setTagInput("");
    }
  };

  const removeTag = (index) => {
    const updated = tags.filter((_, i) => i !== index);
    setTags(updated);
  };


  useEffect(() => {
    auth();
  }, []);

  async function auth() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getPagePermission";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);
      fd.append("pageNo", 8);

      const response = await api.post("user/userCurl", fd);
      if (response.data && response.data.data.length > 0) {
        setUserPermissions(response.data.data[0]);
      }
    } catch (error) {
      setUserPermissions({});
      toast.error("Error fetching permissions.");
    } finally {
      setLoading(false);
    }
  }

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setFile(event.target.files[0]);
      setFileUploaded(true);
      setShowSubmit(false);
      setFileDetails({ questions: [] });
    } else {
      setFile(null);
      setFileUploaded(false);
      setShowSubmit(false);
      setFileDetails({ questions: [] });
    }
  };

  const toggleShowAnswer = (index) => {
    setFileDetails((prevDetails) => {
      const updatedQuestions = prevDetails.questions.map((question, idx) =>
        idx === index
          ? { ...question, showAnswer: !question.showAnswer }
          : question
      );
      return { ...prevDetails, questions: updatedQuestions };
    });
  };

  async function fetchModules() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getAllDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const modulesResponse = await api.post("module/moduleCurl", fd);
      if (Array.isArray(modulesResponse.data.getResponse)) {
        setModules(modulesResponse.data.getResponse);
      } else {
        setModules([]);
      }
    } catch (error) {
      setModules([]);
    }
  }

  async function fetchCourses(moduleId) {
    if (!moduleId) return setCourses([]);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getCourseOnchange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("id", moduleId);

      const courseResponse = await api.post("onchange/onchangeCurl", fd);
      if (Array.isArray(courseResponse.data)) {
        setCourses(courseResponse.data);
      } else {
        setCourses([]);
      }
    } catch (error) {
      setCourses([]);
    }
  }

  async function fetchSubjects(moduleId) {
    if (!moduleId) {
      setSubjects([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getSubjectByModule";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("role", role);
      fd.append("module", moduleId);

      const response = await api.post("subject/subjectCurl", fd);
      console.log("sub", response)

      if (Array.isArray(response.data.data)) {
        setSubjects(response.data.data);
      } else {
        setSubjects([]);
      }
    } catch (error) {
      setSubjects([]);
    }
  }

  async function handleAddChapter() {
    if (!selectedSubject) {
      toast.error("Please select Subject first");
      return;
    }

    if (!newChapterName.trim()) {
      toast.error("Please enter chapter name");
      return;
    }

    setChapterLoading(true);

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("programType", "addChapter");
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("subject", selectedSubject);
      fd.append("chapter", newChapterName.trim());

      const res = await api.post("chapter/chapterCurl", fd);

      if (res.data?.status === true) {
        toast.success("Chapter added");

        await fetchChapters(selectedSubject);

        if (res.data.insertedId) {
          setSelectedChapter(String(res.data.insertedId));
        }

        setShowAddChapter(false);
        setNewChapterName("");
      } else {
        toast.error(res.data?.data || "Failed to add chapter");
      }
    } catch {
      toast.error("Error adding chapter");
    } finally {
      setChapterLoading(false);
    }
  }

  async function handleAddTopic() {
    if (!selectedSubject || !selectedChapter) {
      toast.error("Select Subject and Chapter first");
      return;
    }

    if (!newTopicName.trim()) {
      toast.error("Please enter topic name");
      return;
    }

    setTopicLoading(true);

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("programType", "addTopic");
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("subject", selectedSubject);
      fd.append("chapter", selectedChapter);
      fd.append("topic", newTopicName.trim());

      const res = await api.post("topic/topicCurl", fd);

      if (res.data?.status === true) {
        toast.success("Topic added");

        await fetchTopics(selectedSubject, selectedChapter);

        if (res.data.insertedId) {
          setSelectedTopic(String(res.data.insertedId));
        }

        setShowAddTopic(false);
        setNewTopicName("");
      } else {
        toast.error(res.data?.data || "Failed to add topic");
      }
    } catch {
      toast.error("Error adding topic");
    } finally {
      setTopicLoading(false);
    }
  }



  async function fetchChapters(subjectId) {
    if (!subjectId) {
      setChapters([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getChapterOnChange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("subjectId", subjectId);

      const chapterResponse = await api.post("onchange/onchangeCurl", fd);
      if (Array.isArray(chapterResponse.data.data)) {
        setChapters(chapterResponse.data.data);
      } else {
        setChapters([]);
      }
    } catch (error) {
      setChapters([]);
    }
  }

  async function fetchTopics(subjectId, chapterId) {
    if (!subjectId || !chapterId) {
      setTopics([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getTopicOnChange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("subjectId", subjectId);
      fd.append("chapterId", chapterId);

      const topicResponse = await api.post("onchange/onchangeCurl", fd);
      if (Array.isArray(topicResponse.data.data)) {
        setTopics(topicResponse.data.data);
      } else {
        setTopics([]);
      }
    } catch (error) {
      setTopics([]);
    }
  }

  useEffect(() => {
    if (selectedModule) {
      fetchCourses(selectedModule);
    }
  }, [selectedModule]);

  useEffect(() => {
    if (selectedSubject) {
      fetchChapters(selectedSubject);
    } else {
      setSelectedChapter("");
      setSelectedTopic("");
    }
  }, [selectedSubject]);

  useEffect(() => {
    if (selectedSubject && selectedChapter) {
      fetchTopics(selectedSubject, selectedChapter);
    } else {
      setSelectedTopic("");
    }
  }, [selectedSubject, selectedChapter]);

  const handleViewDetails = async () => {
    if (!file) {
      toast.warning("Please upload a file first.");
      return;
    }

    if (!selectedModule || !selectedSubject || !selectedChapter || !selectedTopic || !selectedQuestionType) {
      toast.warning("Please fill all required fields before viewing details.");
      return;
    }

    setIsLoading(true);

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "viewQuestions";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("questionType", selectedQuestionType);

    fd.append("file", file);

    try {
      const response = await api.post("question/questionCurl", fd);

      console.log("vvvvvv", response)

      if (response.data?.status === false) {
        const errors = response.data?.data?.errors;

        if (Array.isArray(errors) && errors.length > 0) {
          // Show all errors nicely
          errors.forEach(err => {
            toast.error(
              err?.row
                ? `Row ${err.row}: ${err.error}`
                : err.error || "Unknown error"
            );
          });
        } else {
          toast.error(response.data?.message || "Some error occurred.");
        }

        setFileDetails(null);
        setShowPreview(false);
        return;
      }


      if (
        response.data?.data?.questions &&
        Array.isArray(response.data.data.questions) &&
        response.data.data.questions.length > 0
      ) {

        const cleanLatex = (text) => {
          if (!text) return "";

          let decoded = he.decode(text);
          decoded = decoded
            .replace(/\\left\[\s*\{\\begin/g, "\\left[ \\begin")
            .replace(/\\end{array}\}\s*\\right\]/g, "\\end{array} \\right]");

          return decoded;
        };


        const questionsFromApi = response.data.data.questions;
        const THEORY_TYPES = ["3", "5"]; // Subjective + Theory


        const MATCHING_TYPES = ["2", "8"]; // Matching types (adjust if needed)

        let formattedQuestions = questionsFromApi.map((q, index) => {
          const row = q.data || [];
          const isTheory = THEORY_TYPES.includes(selectedQuestionType);
          const isMatching = MATCHING_TYPES.includes(selectedQuestionType);

          return {
            srNo: row[0] || index + 1,
            question: cleanLatex(row[1] || ""),

            // ✅ FIXED OPTIONS LOGIC
            options: isTheory
              ? []
              : isMatching
                ? (Array.isArray(q.options)
                  ? q.options.map(opt => cleanLatex(opt))
                  : [])
                : [row[2], row[3], row[4], row[5]]
                  .map(opt => cleanLatex(opt))
                  .filter(Boolean),

            // ✅ ANSWER LOGIC
            answer: isTheory
              ? cleanLatex(row[2] || "")
              : q.answer || "",

            ansKey: q.answer || "",
            explanation: q.explanation ? cleanLatex(q.explanation) : "",
            tag: q.tag,
            medium: q.medium,
            showAnswer: false
          };
        });

        setFileDetails({ questions: formattedQuestions });
        setShowPreview(true);
        setShowSubmit(true);

      } else {
        toast.error("No valid data found in the uploaded file.");
        setFileDetails(null);
        setShowPreview(false);
      }
    } catch (error) {
      const serverError =
        error?.response?.data?.data?.[0]?.error ||
        error?.response?.data?.message ||
        "Failed to parse the uploaded file.";

      toast.error(serverError);
      setFileDetails(null);
      setShowPreview(false);
    } finally {
      setIsLoading(false);
    }
  };

  async function fetchQuestionType() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getQuestionTypeDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("questionType/questionTypeCurl", fd);

      console.log("qp", response)
      if (Array.isArray(response.data.getQuestionTypeDetails)) {
        setQuestionType(response.data.getQuestionTypeDetails);
      } else {
        setQuestionType([]);
      }
    } catch (error) {
      setQuestionType([]);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!selectedModule) {
      toast.error("Please select Class.");
      return;
    }
    if (!selectedSubject) {
      toast.error("Please select Subject.");
      return;
    }
    if (!selectedChapter) {
      toast.error("Please select Chapter.");
      return;
    }
    if (!selectedTopic) {
      toast.error("Please select Topic.");
      return;
    }
    if (!selectedQuestionType) {
      toast.error("Please select Question Type.");
      return;
    }
    if (!file) {
      toast.error("Please upload a file before submitting.");
      return;
    }

    setIsSubmitting(true);

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");

    const programType =
      selectedQuestionType === "3"
        ? "importQuestions"
        : "importQuestions";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("module", selectedModule);
    fd.append("course", selectedCourse);
    fd.append("subject", selectedSubject);
    fd.append("chapter", selectedChapter);
    fd.append("topic", selectedTopic);
    if (selectedExamType.length > 0) {
      selectedExamType.forEach((exam) => {
        fd.append("examType[]", exam.value);
      });
    }
    fd.append("questionType", selectedQuestionType);
    fd.append("file", file);
    tags.forEach((tag) => {
      fd.append("tags[]", tag);
    });

    try {
      const response = await api.post("question/questionCurl", fd);

      console.log("ff", response)

      if (response.data.status === true) {
        toast.success(response.data.message);

        setSelectedModule("");
        setSelectedCourse("");
        setSelectedSubject("");
        setSelectedChapter("");
        setSelectedTopic("");
        setSelectedQuestionType("");
        setFile(null);
        setID(null);
        setErrorMessage("");
        setFileDetails({ questions: [] });
        setShowPreview(false);
        setShowSubmit(false);

        $('.dropify').dropify('clear');
      } else {
        const errorMessages = response.data.errors.map((errorData, index) => (
          <div key={index} className="error-item">
            <p className="error-title">
              <FiAlertCircle /> <strong>{errorData.error}</strong>
            </p>
            <p className="error-question-id">
              <strong>Question Id: {errorData.question_id}</strong>
            </p>
            <p className="error-content">{renderLatexText(errorData.question)}</p>
            <hr className="error-divider" />
          </div>
        ));

        setErrorMessage(errorMessages);
      }
    } catch (error) {
      toast.error("Error submitting form. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  }

  const renderLatexText = (text, layout = "single", fontSize = "16px") => {
    if (!text) return null;

    if (typeof text !== "string") {
      if (text && typeof text.toString === "function") {
        text = text.toString();
      } else {
        return null;
      }
    }

    let decodedText = he.decode(text);
    decodedText = decodedText.replace(/<br\s*\/?>/gi, "\n");

    const latexAndImageRegex =
      /\\\((.*?)\\\)|\\\[(.*?)\\\]|<img[^>]*\bsrc=(["'])(.*?)\3[^>]*>|\\begin{align}([\s\S]*?)\\end{align}/g;

    const parts = [];
    let lastIndex = 0;
    let match;
    let key = 0;

    while ((match = latexAndImageRegex.exec(decodedText)) !== null) {
      const [fullMatch, inlineLatex, blockLatex, , imageSrc, alignContent] = match;
      const matchIndex = match.index;

      if (matchIndex > lastIndex) {
        const plainText = decodedText.slice(lastIndex, matchIndex);
        plainText.split("\n").forEach((line, i, arr) => {
          if (line) parts.push(<span key={`html-${key++}`}>{parse(line)}</span>);
          if (i < arr.length - 1) parts.push(<br key={`br-${key++}`} />);
        });
      }

      if (imageSrc) {
        parts.push(
          <img
            key={`img-${key++}`}
            src={imageSrc}
            alt="Image"
            style={{
              maxWidth: `calc(${fontSize} * 18)`,
              display: "inline",
              verticalAlign: "middle",
              marginLeft: "4px",
              marginRight: "4px",
            }}
          />
        );
      } else if (alignContent) {
        parts.push(
          <BlockMath key={`align-${key++}`}>
            {`\\begin{align}${alignContent}\\end{align}`}
          </BlockMath>
        );
      } else if (inlineLatex || blockLatex) {
        parts.push(
          <InlineMath key={`inline-${key++}`}>
            {inlineLatex || blockLatex}
          </InlineMath>
        );
      }

      lastIndex = matchIndex + fullMatch.length;
    }

    if (lastIndex < decodedText.length) {
      const remaining = decodedText.slice(lastIndex);
      remaining.split("\n").forEach((line, i, arr) => {
        if (line) parts.push(<span className="normal-inline" key={`html-${key++}`}>{parse(line)}</span>);
        if (i < arr.length - 1) parts.push(<br key={`br-${key++}`} />);
      });
    }

    return <span style={{ whiteSpace: "normal", display: "inline" }}>{parts}</span>;
  };

  useEffect(() => {
    fetchModules();

    fetchQuestionType();
    fetchExamType()

    $(".dropify").dropify({
      messages: {
        default: "Drag and drop a file here or click",
        replace: "Drag and drop or click to replace",
        remove: "Remove",
        error: "Oops, something wrong happened.",
      },
    });

    $(".dropify").on("change", function (e) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      setFileDetails({ questions: [] });
      setShowPreview(false);
    });
  }, []);

  async function fetchExamType() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getExamTypes");

      const response = await api.post("question/examType", fd);

      if (response.data?.status) {
        const options = response.data.examTypes.map((exam) => ({
          value: exam.id,
          label: exam.examType,
        }));

        setExamTypes(options);
      }
    } catch (error) {
      console.error("Error fetching exam types:", error);
    }
  }

  $(".dropify").on("dropify.afterClear", function () {
    setFile(null);
    setFileUploaded(false);
    setShowSubmit(false);
    setFileDetails({ questions: [] });
    setShowPreview(false);
  });

  const resetForm = () => {
    setSelectedModule("");
    setSelectedCourse("");
    setSelectedSubject("");
    setSelectedChapter("");
    setSelectedTopic("");
    setSelectedQuestionType("");
    setFile(null);
    setFileDetails({ questions: [] });
    setErrorMessage("");
    setShowPreview(false);
    setShowSubmit(false);
    setTags([]);
    setTagInput("");

    $('.dropify').dropify('clear');
    toast.success("Form reset successfully!");
  };

  const renderPreview = () => {
    return (
      <div className="preview-container">
        <div className="preview-card">
          <div className="preview-header">
            <h4><FiEye /> Questions Preview ({fileDetails.questions.length} questions)</h4>
            <button className="close-preview" onClick={() => setShowPreview(false)}>
              <FiX size={20} />
            </button>
          </div>

          <div className="preview-content">
            {fileDetails.questions.map((question, index) => (
              <div key={index} className="question-preview-card">
                <div className="question-header">
                  <span className="question-number">Question {question.srNo}</span>
                  <button
                    className="toggle-answer-btn"
                    onClick={() => toggleShowAnswer(index)}
                  >
                    {question.showAnswer ? "Hide Answer" : "Show Answer"}
                  </button>
                </div>

                <div className="question-content">
                  <div className="question-text">
                    {renderLatexText(question.question)}
                  </div>

                  {Array.isArray(question.options) && question.options.length > 0 && (
                    <div className="options-preview">
                      <h6>Options:</h6>
                      <div className="options-grid">
                        {question.options.map((option, idx) => (
                          <div key={idx} className="option-item">
                            <div className="option-letter">{idx + 1}</div>
                            <div className="option-text">
                              {renderLatexText(option)}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {question.showAnswer && (
                    <div className="answer-section">
                      <div className="answer-item">
                        <strong>Answer:</strong> {renderLatexText(question.answer || question.ansKey)}
                      </div>
                      {question.explanation && (
                        <div className="explanation-item">
                          <strong>Explanation:</strong> {renderLatexText(question.explanation)}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const getSampleFile = (questionType) => {


    if (questionType === "10") {
      return "/Multiple_Correct_Options_Question.docx";
    }

    if (questionType === "9") {
      return "/Image_Based_Diagram_Based_Questions.docx";
    }

    if (questionType === "8") {
      return "/Matching_Type_Questions.docx";
    }

    if (questionType === "7") {
      return "/Statement_Based_Questions.docx";
    }

    if (questionType === "6") {
      return "/Assertion_and_Reasoning_Questions.docx";
    }


    if (questionType === "5") {
      return "/Theory_Question.docx";
    }

    if (questionType === "3") {
      return "/Subjective_Question.docx";
    }
    if (questionType === "2") {
      return "/Matching_Qustion.docx";
    }
    return "/MCQ.docx";
  };


  return (
    <div className="import-question-container">
      <ToastContainer />



      {userPermissions.is_view === "0" ? (
        <div className="permission-denied">
          <h4 className="text-danger">Permission Denied</h4>
        </div>
      ) : (
        <>
          {/* Header */}


          {/* Main Form */}
          <div className="import-question-main">
            <form onSubmit={handleSubmit} className="import-form">
              {/* Category Selection Card */}
              <div className="form-card">
                <div className="card-header">
                  <h3><FiBook /> Import Questions</h3>
                  <p className="card-subtitle">Select the category for your questions</p>
                </div>

                <div className="card-content">
                  <div className="form-grid">
                    {/* Class */}
                    <div className="form-group">
                      <label className="form-label">
                        <FiBook /> Class <span className="required">*</span>
                      </label>
                      <select
                        className="form-select"
                        value={selectedModule}
                        onChange={(e) => {
                          const moduleId = e.target.value;
                          setSelectedModule(moduleId);

                          // RESET dependent fields
                          setSelectedSubject("");
                          setSelectedChapter("");
                          setSelectedTopic("");

                          setSubjects([]);
                          setChapters([]);
                          setTopics([]);

                          // FETCH dependent data
                          fetchCourses(moduleId);
                          fetchSubjects(moduleId);
                        }}
                      >

                        <option value="">Select a Class</option>
                        {modules.map((module) => (
                          <option key={module.id} value={module.id}>
                            {module.moduleName}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Subject */}
                    <div className="form-group">
                      <label className="form-label">
                        <FiFileText /> Subject <span className="required">*</span>
                      </label>
                      <select
                        className="form-select"
                        value={selectedSubject}
                        onChange={(e) => {
                          const subjectId = e.target.value;
                          setSelectedSubject(subjectId);
                        }}
                      >
                        <option value="">Select a Subject</option>
                        {subjects.map((subject) => (
                          <option key={subject.id} value={subject.id}>
                            {subject.subjectName}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Chapter */}
                    <div className="form-group">
                      <label className="form-label">
                        <FiList /> Chapter <span className="required">*</span>
                      </label>
                      <select
                        className="form-select"
                        value={selectedChapter}
                        onChange={(e) => {
                          if (e.target.value === "__add__") {
                            setShowAddChapter(true);
                            return;
                          }
                          setSelectedChapter(e.target.value);
                        }}
                      >
                        <option value="">Select a Chapter</option>

                        {/* ✅ ONLY after Subject */}
                        {selectedSubject && (
                          <option value="__add__">➕ Add Chapter</option>
                        )}

                        {chapters.map((chapter) => (
                          <option key={chapter.id} value={chapter.id}>
                            {chapter.chapterName}
                          </option>
                        ))}
                      </select>

                    </div>

                    {/* Topic */}
                    <div className="form-group">
                      <label className="form-label">
                        <FiList /> Topic <span className="required">*</span>
                      </label>
                      <select
                        className="form-select"
                        value={selectedTopic}
                        onChange={(e) => {
                          if (e.target.value === "__add__") {
                            setShowAddTopic(true);
                            return;
                          }
                          setSelectedTopic(e.target.value);
                        }}
                      >
                        <option value="">Select a Topic</option>

                        {/* ✅ ONLY after Chapter */}
                        {selectedChapter && (
                          <option value="__add__">➕ Add Topic</option>
                        )}

                        {topics.map((topic) => (
                          <option key={topic.id} value={topic.id}>
                            {topic.topicName}
                          </option>
                        ))}
                      </select>

                    </div>

                    {/* Exam Type */}
                    <div className="form-group">
                      <label className="form-label">
                        Exam Type
                      </label>

                      <Select
                        options={examTypes}
                        isMulti
                        value={selectedExamType}
                        onChange={(selected) => setSelectedExamType(selected)}
                        placeholder="Select Exam Types"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 })
                        }}
                      />
                    </div>

                    {/* Question Type */}
                    <div className="form-group">
                      <label className="form-label">
                        <FiType /> Question Type <span className="required">*</span>
                      </label>
                      <select
                        className="form-select"
                        value={selectedQuestionType}
                        onChange={(e) => {
                          setSelectedQuestionType(e.target.value);
                        }}
                      >
                        <option value="">Question Type</option>
                        {questionType.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.questionType}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Tags */}
                    {/* Tags */}
                    <div className="form-group">
                      <label className="form-label">
                        <FiList /> Tags
                      </label>

                      <input
                        type="text"
                        className="form-select"
                        placeholder="Type tag and press Enter"
                        value={tagInput}
                        onChange={(e) => setTagInput(e.target.value)}
                        onKeyDown={handleTagKeyDown}
                      />

                      {/* Tag list */}
                      <div className="tag-container">
                        {tags.map((tag, index) => (
                          <span key={index} className="tag-item">
                            {tag}
                            <button
                              type="button"
                              className="tag-remove"
                              onClick={() => removeTag(index)}
                            >
                              ×
                            </button>
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* File Upload Card */}
              <div className="form-card">
                <div className="card-header">
                  <h3><FiUpload /> File Upload</h3>
                  <p className="card-subtitle">
                    Upload your questions file
                    <a
                      href={getSampleFile(selectedQuestionType)}
                      className="download-sample"
                      download
                    >
                      <FiDownload /> Download Sample
                    </a>

                  </p>
                </div>

                <div className="card-content">
                  <div className="upload-section">
                    <div className="upload-instructions">
                      <p><strong>Supported formats:</strong> .doc, .docx, .xls, .xlsx</p>
                      <p><strong>Instructions:</strong> Ensure your file follows the sample format</p>
                    </div>

                    <div className="file-upload-container">
                      <input
                        type="file"
                        className="dropify"
                        id="fileUploader"
                        accept=".doc,.docx,.xls,.xlsx"
                        onChange={handleFileChange}
                        data-allowed-file-extensions="doc docx xls xlsx"
                      />
                    </div>

                    {errorMessage && (
                      <div className="error-container">
                        <div className="error-header">
                          <FiAlertCircle /> Import Errors
                        </div>
                        <div className="error-content">
                          {errorMessage}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Form Actions */}
              <div className="form-actions">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={resetForm}
                  disabled={isLoading || isSubmitting}
                >
                  <FiX /> Reset
                </button>

                <button
                  type="button"
                  className="btn preview"
                  onClick={handleViewDetails}
                  disabled={isLoading || isSubmitting || !file || !selectedQuestionType}
                >
                  {isLoading ? (
                    <>
                      <FiLoader className="spinner" />
                      Loading...
                    </>
                  ) : (
                    <>
                      <FiEye /> View Details
                    </>
                  )}
                </button>

                <button
                  type="submit"
                  className="btn primary"
                  disabled={isLoading || isSubmitting || !showSubmit}
                >
                  {isSubmitting ? (
                    <>
                      <FiLoader className="spinner" />
                      Submitting...
                    </>
                  ) : (
                    <>
                      <FiSave /> Import Questions
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>

          {/* Preview Modal */}
          {showPreview && renderPreview()}

          {showAddChapter && (
            <div className="modal-overlay">
              <div className="modal-card">
                <h3>➕ Add Chapter</h3>

                <input
                  className="form-control"
                  value={newChapterName}
                  onChange={(e) => setNewChapterName(e.target.value)}
                  placeholder="Enter chapter name"
                />

                <div className="modal-actions">
                  <button className="btn btn-danger" onClick={() => setShowAddChapter(false)}>
                    Cancel
                  </button>
                  <button className="btn primary" onClick={handleAddChapter} disabled={chapterLoading}>
                    {chapterLoading ? "Adding..." : "Add Chapter"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {showAddTopic && (
            <div className="modal-overlay">
              <div className="modal-card">
                <h3>➕ Add Topic</h3>

                <input
                  className="form-control"
                  value={newTopicName}
                  onChange={(e) => setNewTopicName(e.target.value)}
                  placeholder="Enter topic name"
                />

                <div className="modal-actions">
                  <button className="btn btn-danger" onClick={() => setShowAddTopic(false)}>
                    Cancel
                  </button>
                  <button className="btn primary" onClick={handleAddTopic} disabled={topicLoading}>
                    {topicLoading ? "Adding..." : "Add Topic"}
                  </button>
                </div>
              </div>
            </div>
          )}


          <style>
            {`
              .import-question-container {
                min-height: 100vh;
                background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
                padding: 1.5rem;
              }

              /* ===== ADD CHAPTER / TOPIC MODAL ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-card {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  width: 420px;
  max-width: 90%;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}


           
              /* Header */
              .import-question-header {
                background: white;
                border-radius: 1rem;
                padding: 1.5rem;
                margin-bottom: 1.5rem;
                box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                border: 1px solid #e2e8f0;
              }

              .header-content h1 {
                font-size: 1.75rem;
                font-weight: 700;
                color: #1f2937;
                margin: 0 0 0.5rem;
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }

              .header-content p {
                font-size: 0.875rem;
                color: #6b7280;
                margin: 0 0 1rem;
              }

              /* Breadcrumb */
              .breadcrumb {
                padding-top: 1rem;
                border-top: 1px solid #f3f4f6;
              }

              .breadcrumb-list {
                display: flex;
                align-items: center;
                gap: 0.5rem;
                list-style: none;
                padding: 0;
                margin: 0;
              }

              .breadcrumb-list li {
                display: flex;
                align-items: center;
                gap: 0.5rem;
              }

              .breadcrumb-item {
                display: flex;
                align-items: center;
                gap: 0.5rem;
                color: #6b7280;
                text-decoration: none;
                font-size: 0.875rem;
                transition: color 0.2s;
              }

              .breadcrumb-item:hover {
                color: #3b82f6;
              }

              .breadcrumb-item.active {
                color: #1f2937;
                font-weight: 500;
              }

              .breadcrumb-separator {
                color: #9ca3af;
                width: 16px;
                height: 16px;
              }

              /* Main Form */
              .import-question-main {
                display: flex;
                flex-direction: column;
                gap: 1.5rem;
              }

              /* Form Cards */
              .form-card {
                background: white;
                border-radius: 1rem;
                border: 1px solid #e2e8f0;
                box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                overflow: hidden;
              }

              .card-header {
                padding: 1.25rem 1.5rem;
                border-bottom: 1px solid #f3f4f6;
                background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
              }

              .card-header h3 {
                font-size: 1.125rem;
                font-weight: 600;
                color: #1f2937;
                margin: 0 0 0.5rem;
                display: flex;
                align-items: center;
                gap: 0.5rem;
              }

              .card-subtitle {
                font-size: 0.875rem;
                color: #6b7280;
                margin: 0;
                display: flex;
                align-items: center;
                gap: 1rem;
              }

              .download-sample {
                display: inline-flex;
                align-items: center;
                gap: 0.25rem;
                color: #3b82f6;
                text-decoration: none;
                font-weight: 500;
                transition: color 0.2s;
              }

              .download-sample:hover {
                color: #2563eb;
                text-decoration: underline;
              }

              .card-content {
                padding: 1.5rem;
              }

              /* Form Grid */
              .form-grid {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                gap: 1.5rem;
              }

              .form-group {
              
              }

              .form-label {
                display: block;
                font-size: 0.875rem;
                font-weight: 600;
                color: #374151;
                margin-bottom: 0.5rem;
                display: flex;
                align-items: center;
                gap: 0.5rem;
              }

              .required {
                color: #ef4444;
                font-weight: 600;
              }

              /* Form Controls */
              .form-select {
                width: 100%;
                padding: 0.625rem 0.875rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                color: #374151;
                background: white;
                transition: all 0.2s;
              }

              .form-select:focus {
                outline: none;
                border-color: #3b82f6;
                box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
              }

              /* Upload Section */
              .upload-section {
                display: flex;
                flex-direction: column;
                gap: 1.5rem;
              }

              .upload-instructions {
                background: #f8fafc;
                border: 1px solid #e2e8f0;
                border-radius: 0.5rem;
                padding: 1rem;
              }

              .tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.tag-item {
  background: #e0f2fe;
  color: #0369a1;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.tag-remove {
  border: none;
  background: transparent;
  margin-left: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #0369a1;
}

              .upload-instructions p {
                margin: 0.5rem 0;
                font-size: 0.875rem;
                color: #4b5563;
              }

              .file-upload-container {
                border: 2px dashed #d1d5db;
                border-radius: 0.5rem;
                padding: 1.5rem;
                background: #f9fafb;
                transition: all 0.3s;
              }

              .file-upload-container:hover {
                border-color: #3b82f6;
                background: #f0f9ff;
              }

              /* Dropify Customization */
              .dropify-wrapper {
                border: none !important;
                border-radius: 0.5rem !important;
                background: white !important;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
              }

              .dropify-wrapper:hover {
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
              }

              /* Error Container */
              .error-container {
                background: #fef2f2;
                border: 1px solid #fecaca;
                border-radius: 0.5rem;
                overflow: hidden;
              }

              .error-header {
                background: #ef4444;
                color: white;
                padding: 0.75rem 1rem;
                font-weight: 600;
                display: flex;
                align-items: center;
                gap: 0.5rem;
              }

              .error-content {
                padding: 1rem;
                max-height: 300px;
                overflow-y: auto;
              }

              .error-item {
                margin-bottom: 1rem;
              }

              .error-title {
                color: #dc2626;
                margin-bottom: 0.5rem;
                display: flex;
                align-items: center;
                gap: 0.5rem;
              }

              .error-question-id {
                color: #7f1d1d;
                margin-bottom: 0.5rem;
              }

              .error-content {
                color: #4b5563;
                font-size: 0.875rem;
              }

              .error-divider {
                border: none;
                border-top: 1px solid #fca5a5;
                margin: 1rem 0;
              }

              /* Form Actions */
              .form-actions {
                display: flex;
                justify-content: flex-end;
                gap: 1rem;
                padding: 1.5rem;
                background: white;
                border-radius: 1rem;
                border: 1px solid #e2e8f0;
                box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
              }

              .btn {
                display: inline-flex;
                align-items: center;
                gap: 0.5rem;
                padding: 0.75rem 1.5rem;
                border: none;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.2s;
              }

              .btn:disabled {
                opacity: 0.5;
                cursor: not-allowed;
              }

              .btn.primary {
                background: #3b82f6;
                color: white;
              }

              .btn.primary:hover:not(:disabled) {
                background: #2563eb;
                transform: translateY(-1px);
                box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
              }

              .btn.secondary {
                background: #f3f4f6;
                color: #374151;
                border: 1px solid #e5e7eb;
              }

              .btn.secondary:hover:not(:disabled) {
                background: #e5e7eb;
              }

              .btn.preview {
                background: #8b5cf6;
                color: white;
              }

              .btn.preview:hover:not(:disabled) {
                background: #7c3aed;
                transform: translateY(-1px);
                box-shadow: 0 4px 12px rgba(139, 92, 246, 0.2);
              }

              .spinner {
                animation: spin 1s linear infinite;
              }

              @keyframes spin {
                to { transform: rotate(360deg); }
              }

              /* Preview Modal */
              .preview-container {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 1000;
                backdrop-filter: blur(3px);
                padding: 1rem;
              }

              .preview-card {
                background: white;
                border-radius: 1rem;
                width: 100%;
                max-width: 800px;
                max-height: 80vh;
                overflow: hidden;
                box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
              }

              .preview-header {
                padding: 1.5rem;
                border-bottom: 1px solid #f3f4f6;
                display: flex;
                justify-content: space-between;
                align-items: center;
                background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
              }

              .preview-header h4 {
                font-size: 1.25rem;
                font-weight: 600;
                color: #1f2937;
                margin: 0;
                display: flex;
                align-items: center;
                gap: 0.5rem;
              }

              .close-preview {
                background: none;
                border: none;
                color: #9ca3af;
                cursor: pointer;
                padding: 0.5rem;
                border-radius: 0.5rem;
                transition: all 0.2s;
              }

              .close-preview:hover {
                background: #f3f4f6;
                color: #374151;
              }

              .preview-content {
                padding: 1.5rem;
                overflow-y: auto;
                max-height: calc(80vh - 80px);
              }

              .question-preview-card {
                background: white;
                border: 1px solid #e5e7eb;
                border-radius: 0.75rem;
                margin-bottom: 1rem;
                overflow: hidden;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
              }

              .question-header {
                padding: 1rem 1.25rem;
                background: #f9fafb;
                border-bottom: 1px solid #f3f4f6;
                display: flex;
                justify-content: space-between;
                align-items: center;
              }

              .question-number {
                font-weight: 600;
                color: #374151;
              }

              .toggle-answer-btn {
                background: #3b82f6;
                color: white;
                border: none;
                border-radius: 0.5rem;
                padding: 0.375rem 0.75rem;
                font-size: 0.75rem;
                font-weight: 500;
                cursor: pointer;
                transition: all 0.2s;
              }

              .toggle-answer-btn:hover {
                background: #2563eb;
                transform: translateY(-1px);
              }

              .question-content {
                padding: 1.25rem;
              }

              .question-text {
                font-size: 0.9375rem;
                line-height: 1.6;
                color: #4b5563;
                margin-bottom: 1rem;
              }

              .options-preview {
                margin-top: 1rem;
              }

              .options-preview h6 {
                font-size: 0.875rem;
                font-weight: 600;
                color: #374151;
                margin-bottom: 0.75rem;
              }

              .options-grid {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                gap: 0.75rem;
              }

              .option-item {
                display: flex;
                gap: 0.75rem;
                padding: 0.75rem;
                background: #f9fafb;
                border-radius: 0.5rem;
                border: 1px solid #f3f4f6;
              }

              .option-letter {
                width: 1.5rem;
                height: 1.5rem;
                background: #e5e7eb;
                color: #374151;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 700;
                font-size: 0.75rem;
                flex-shrink: 0;
              }

              .option-text {
                font-size: 0.875rem;
                line-height: 1.5;
                color: #1f2937;
                flex: 1;
              }

              .answer-section {
                margin-top: 1rem;
                padding: 1rem;
                background: #f0f9ff;
                border-radius: 0.5rem;
                border: 1px solid #e0f2fe;
              }

              .answer-item, .explanation-item {
                margin-bottom: 0.5rem;
                font-size: 0.875rem;
                line-height: 1.5;
              }

              .answer-item strong, .explanation-item strong {
                color: #0369a1;
              }

              /* Permission Denied */
              .permission-denied {
                display: flex;
                justify-content: center;
                align-items: center;
                min-height: 50vh;
              }

              /* Responsive Design */
              @media (max-width: 768px) {
                .import-question-container {
                  padding: 1rem;
                }

                .form-grid {
                  grid-template-columns: 1fr;
                }

                .form-actions {
                  flex-direction: column;
                }

                .btn {
                  width: 100%;
                  justify-content: center;
                }

                .preview-card {
                  margin: 0.5rem;
                }
              }

              @media (max-width: 480px) {
                .import-question-header {
                  padding: 1rem;
                }

                .header-content h1 {
                  font-size: 1.5rem;
                }

                .card-content {
                  padding: 1rem;
                }

                .preview-header h4 {
                  font-size: 1rem;
                }
              }
            `}
          </style>
        </>
      )}
    </div>
  );
};

export default ImportQuestion;